/**
 * @generated SignedSource<<9773fa5a37e68c4e59d53a5ce1cca3f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandMessageTemplateDeleteInput = {
  id: string;
};
export type BrandMessageTemplateId_brandMessageTemplateDeleteMutation$variables = {
  input: BrandMessageTemplateDeleteInput;
};
export type BrandMessageTemplateId_brandMessageTemplateDeleteMutation$data = {
  readonly brandMessageTemplateDelete: {
    readonly id: string;
  };
};
export type BrandMessageTemplateId_brandMessageTemplateDeleteMutation = {
  response: BrandMessageTemplateId_brandMessageTemplateDeleteMutation$data;
  variables: BrandMessageTemplateId_brandMessageTemplateDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTemplateId_brandMessageTemplateDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTemplate",
        "kind": "LinkedField",
        "name": "brandMessageTemplateDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTemplateId_brandMessageTemplateDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTemplate",
        "kind": "LinkedField",
        "name": "brandMessageTemplateDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fff5e2642ea548f9a2e5e731f87ca722",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTemplateId_brandMessageTemplateDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BrandMessageTemplateId_brandMessageTemplateDeleteMutation(\n  $input: BrandMessageTemplateDeleteInput!\n) {\n  brandMessageTemplateDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b866aa13444ee70713dd0d3a9f589058";

export default node;
